<div class="left-side" [ngClass]="{'header-ratio-2-1': headerRatio21 }">

    <div class="report-logo" *ngIf="reportOptions.logoLink">
        <img [src]="reportOptions.logoLink" [alt]="reportOptions.title" />
    </div>

    <div class="title-block">
        <div class="subtitle">
            {{ reportOptions.subtitle.toUpperCase() }}
        </div>
        <div class="title">        
            {{ reportOptions.title }}<sup *ngIf="reportOptions.titleIndexText">{{ reportOptions.titleIndexText }}</sup>
        </div>
    </div>
</div>

<div class="middle-panel">
    <ngx-gauge [type]="gaugeOptions.gaugeType" *ngIf="gaugeOptions" (window:resize)="resizeGauge()" 
        [value]="gaugeOptions.value | number: '1.0-0'" 
        [label]="gaugeOptions.label"
        [size]="gaugeOptions.size"
        foregroundColor="#17A5E3"
        [ngClass]="{'gauge1': gaugeOptions.size == 62 }"
        [append]="gaugeOptions.appendText">
    </ngx-gauge>
</div>

<div class="right-side" [ngClass]="{'line3': legend.length >= 3}">

    <div *ngIf="reportOptions.company" class="report-company">
        {{ reportOptions.company }}
    </div>
    <div *ngIf="showLegend && reportOptions?.subject" class="report-subject">
        {{ reportOptions.subject }}
    </div>
    <div *ngIf="reportOptions?.showCurrentDate" class="report-date">
        Dátum: {{ currentDate | localizedDate }}
    </div>
    <app-legend [data]="legend" [showIcon]="showLegendIcon" *ngIf="showLegend"></app-legend>
    
    <div class="review-interval" *ngIf="reportOptions.dateFrom && reportOptions.dateTo">{{ reportOptions.dateFrom | datePlain }} - {{ reportOptions.dateTo | datePlain }}</div>
</div>